import { observable, action } from 'mobx';
import * as Bean from './bean';
import ChatMessage from 'enum/ChatMessage';
import * as Api from 'api/api';

class Service {
  @observable _show = false;
  @observable _message = '';
  @observable _messageList = [];

  get show() {
    return this._show;
  }
  set show(value) {
    this._show = value;
  }
  get message() {
    return this._message;
  }
  set message(value) {
    this._message = value;
  }
  get messageList() {
    return this._messageList;
  }
  set messageList(value) {
    this._messageList = value;
  }

  @action async addMessage({ message, userType }) {
    this._messageList.push(new Bean.Message(message, userType));
  }

  @action async sendMessage(message, callback) {
    try {
      this._message = '';

      const { answer } = await Api.askQuestion({ question: message });

      this.addMessage({ message: answer, userType: ChatMessage.TO });
      if (callback) {
        callback();
      }
    } catch (error) {}
  }
  @action init() {
    this._messageList.push(
      new Bean.Message('你好，有什么可以帮到你呢?', ChatMessage.TO)
    );
  }
}

const service = new Service();

export default service;
